import { Fancybox } from '@fancyapps/ui'

Fancybox.defaults.closeButton = 'outside'

import './video.scss'
